module.exports = __webpack_public_path__ + "assets/img/340b58ce70a581ef9c5cab251ca98316.svg";